<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-farm"
              v-model="casesConfirmationForm.farm_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary"
                v-for="item in farms"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('diseases.plague_or_disease') }} </label>
            <br />
            <el-select
              @change="
                selectAllFromSelect(
                  'casesConfirmationForm.diseases_id',
                  diseases
                )
              "
              clearable
              filterable
              collapse-tags
              multiple
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-diseases"
              v-model="casesConfirmationForm.diseases_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary selected-all"
                v-for="disease in diseases"
                :key="disease.id + disease.name"
                :label="disease.name"
                :value="disease.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('common_words.status') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-status"
              v-model="casesConfirmationForm.status_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary"
                v-for="item in [
                  { id: 0, value: $t('common_words.confirm_waiting') },
                  { id: 1, value: $t('common_words.confirmed') },
                ]"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.date') }} *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm required-date"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
      <card v-if="confirmationCatching">
        <div v-if="isIndex()">
          <div class="row">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  :render-header="renderHeader"
                  v-for="column in tableColumns"
                  :key="column.label"
                  :width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                ></el-table-column>

                <el-table-column
                  :label="$t('common_words.image')"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      alt="Sin Imagen"
                      class="photo_capture"
                      @click="zoom(scope.row.image)"
                      :preview-src-list="srcList"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <span v-else></span>
                  </template>
                </el-table-column>

                <el-table-column
                  width="250px"
                  prop="disease_name"
                  :label="$t('diseases.suspicions')"
                >
                </el-table-column>

                <el-table-column
                  width="250px"
                  prop="disease_status"
                  :label="$t('common_words.level_or_status')"
                >
                  <template slot-scope="scope">
                    <template
                      v-if="
                        queriedData[scope.$index].confirmacion == 0
                          ? false
                          : true
                      "
                      >{{ scope.row['disease_status'] }}</template
                    >

                    <el-select
                      v-if="
                        diseases.filter(
                          (disease) =>
                            disease.id == queriedData[scope.$index].disease_id
                        )[0].catch_type == '1' &&
                        queriedData[scope.$index].confirmacion == 0
                          ? true
                          : false
                      "
                      clearable
                      :disabled="
                        queriedData[scope.$index].confirmacion == 0
                          ? false
                          : true
                      "
                      size="large"
                      style="margin-top: 15px"
                      class="select-default custom-width-select mb-3 shadow-sm"
                      v-model="queriedData[scope.$index].disease_status_id"
                    >
                      <el-option
                        class="select-default"
                        v-for="item in diseases.filter(
                          (disease) =>
                            disease.id == queriedData[scope.$index].disease_id
                        )[0].disease_statuses"
                        :key="item.id"
                        :label="`${item.state_number} - ${item.disease_status}`"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column
                  width="250px"
                  :label="$t('diseases.results_deadlines')"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      v-if="renderComponent"
                      :picker-options="
                        getPickerOptions(queriedData[scope.$index].date_save)
                      "
                      :id="
                        'date' +
                        queriedData[scope.$index].disease_sample_detail_id
                      "
                      v-model="queriedData[scope.$index].confirmation_date"
                      type="date"
                      :placeholder="`${$t('common_words.select2')}...`"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>

                <el-table-column
                  width="220px"
                  :label="$t('diseases.diagnosis')"
                >
                  <template slot-scope="scope">
                    <el-select
                      :placeholder="`${$t('common_words.select')}...`"
                      clearable
                      multiple
                      collapse-tags
                      @change="
                        selectAllFromSelect(
                          `queriedData[${scope.$index}].confirmacion_ids`,
                          diseases
                        )
                      "
                      size="large"
                      class="select-primary custom-width-select shadow-sm"
                      v-model="queriedData[scope.$index].confirmacion_ids"
                      filterable
                    >
                      <el-option
                        class="select-primary select-all"
                        v-for="disease in diseases"
                        :key="disease.id + disease.name + '-confirmation'"
                        :label="disease.name"
                        :value="disease.id"
                      >
                      </el-option>
                      <!-- <el-option
                        class="select-default"
                        v-for="item in [
                          { id: 1, value: 'SI' },
                          { id: 0, value: 'NO' }
                        ]"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                      ></el-option> -->
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  width="220px"
                  :label="$t('common_words.pdf_result')"
                >
                  <template slot-scope="scope">
                    <el-upload
                      id="confirmationpdf"
                      class="upload-demo custom-upload"
                      :data="{
                        ...uploadData,
                        disease_sample_detail_id:
                          queriedData[scope.$index].disease_sample_detail_id,
                        code: queriedData[scope.$index].code,
                        code_detail: queriedData[scope.$index].code_detail,
                      }"
                      :headers="headerInfo"
                      :action="
                        getAxiosURL() +
                        '/auth/diseases/casesconfirmation/uploadpdf'
                      "
                      :auto-upload="true"
                      :multiple="false"
                      :on-preview="
                        handlePreview.bind(
                          this,
                          queriedData[scope.$index].code_detail,
                          queriedData[scope.$index].code,
                          queriedData[scope.$index].confirmation_pdf
                        )
                      "
                      :limit="1"
                      :file-list="queriedData[scope.$index].confirmation_pdf"
                      :on-remove="
                        handleRemoveFile.bind(
                          this,
                          queriedData[scope.$index].code_detail
                        )
                      "
                      :on-exceed="handleExceed"
                      :on-success="
                        handleSuccess.bind(
                          this,
                          queriedData[scope.$index].code_detail
                        )
                      "
                    >
                      <el-button size="small" type="success"
                        ><center>
                          {{ $t('common_words.upload_pdf') }}
                        </center></el-button
                      >
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <br />
          </div>
          <div class="row mt-3">
            <br />
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div class="row">
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <l-button
                wide
                type="info"
                class="btn-filter"
                @click="saveConfirmation"
              >
                {{ $t('common_words.mayus_save') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { DISK_URL } from 'src/util/Util';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './confirmationTable.js';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },
  data() {
    return {
      casesConfirmationForm: {
        farm_id: [],
        status_id: 0,
        por_confirmar: false,
        diseases_id: [],
      },
      uploadData: {
        user: this.$store.state.auth.user.id,
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      // fileList: [],
      rangeDate: [],
      farms: [],
      confirmationCatching: false,
      srcList: [],
      tableData: [],
      diseases: [],
      pagination: {},
      tableColumns: [],
    };
  },

  computed: {
    ...configTable().Search,
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinDatePicker,
    MixinMenu,
    MixinValidations,
  ],

  watch: {
    '$i18n.locale': ['getSelectAll', 'setupTable', 'forceRerender'],
  },

  methods: {
    getSelectAll() {
      this.diseases = this.concatAll(this.diseases.splice(1));
    },

    getPickerOptions(dateInitial) {
      return {
        disabledDate(time) {
          return time.getTime() < moment(dateInitial);
        },
      };
    },

    getFileName(file) {
      file;
      return;
    },

    handleRemoveFile(code_detail, file) {
      this.removeFileUpload(code_detail, file);
    },

    removeFileUpload(code_detail, file) {
      this.showHideLoading(true);
      Axios.postMasters({
        route: 'diseases/casesconfirmation/deletepdf',
        code_detail,
        // name: file.name,
        // nameFile: this.uploadData.nameFile,
        // user: this.uploadData.user,
        // disease_id: this.model.id
      }).then(() => {
        this.showHideLoading();
        // this.model.fileList = [];
        // localStorage.setItem(
        //   "listFiles",
        //   JSON.stringify(this.model.fileList)
        // );
      });
    },

    handleExceed(files) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')}`
      );
    },

    handlePreview(code_detail, code, data, file) {
      if (data.length === 0) return;

      const row = this.tableData.find((el) => el.code_detail === code_detail);
      const diskName = 'diseasesconfirmations';
      const url =
        row.confirmation_pdf.length === 0
          ? `${DISK_URL}${diskName}/${code}/${code_detail}/${encodeURIComponent(
              file.name
            )}`
          : `${DISK_URL}${diskName}/${file.url}`;

      window.open(url, '_blank');
    },

    handleSuccess(code_detail, res, file) {
      file.editFile = true;
      this.verifyUpload(file, code_detail);
    },

    verifyUpload(file, code_detail) {
      this.showHideLoading(true);
      const isPDF = file.name.includes('.pdf');
      //const isJPG = file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isPDF) {
        SweetAlert.warning(i18n.t('common_words.pdf_file_warning'));

        let element = this.tableData.find(
          (element) => element.code_detail == code_detail
        );
        element.confirmation_pdf = [];
        this.showHideLoading();
      }
      this.showHideLoading();

      return isPDF;
    },

    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },
    validate() {
      this.tableData = [];
      this.confirmationCatching = false;
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.casesConfirmationForm.farm_id.length === 0) {
            return this.validationInputsRequired('farm');
          } else if (this.casesConfirmationForm.diseases_id.length === 0) {
            return this.validationInputsRequired('diseases');
          } else if (![0, 1].includes(this.casesConfirmationForm.status_id)) {
            return this.validationInputsRequired('status');
          } else {
            this.loadData();
          }
        }
      });
    },

    changeDisease($event, index) {
      index.disease_status = '';
      index.disease_status_id = null;
    },
    change() {
      this.confirmationCatching = false;
    },
    loadData() {
      this.pagination.currentPage = 1;
      let data = {
        farm_id: this.casesConfirmationForm.farm_id,
        status: this.casesConfirmationForm.status_id,
        diseases_id: this.casesConfirmationForm.diseases_id,
        route: 'diseases/casesconfirmation',
        init: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        end: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
      };
      this.showHideLoading(true);
      Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          if (response.data.length > 0) {
            // este ciclo es necesario por que el date picker settea una dia menos que el enviado en la data
            response.data.forEach((element) => {
              element.confirmation_date = moment(
                element.confirmation_date,
                'YYYY-MM-DD'
              );
            });
            this.tableData = response.data;
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.confirmationCatching = true;
          } else {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
        })
        .catch((error) => {
          this.showHideLoading();
          console.log(error);
        });
    },

    saveConfirmation() {
      let data = {
        route: '',
        confirmations: [],
      };

      data.route = 'diseases/casesconfirmation/store';

      // if (this.casesConfirmationForm.por_confirmar) {
      //   data.route = "diseases/casesconfirmation/store";
      // } else {
      //   data.route = "diseases/casesconfirmation/update";
      // }

      data.confirmations = this.tableData.filter(
        // element => element.confirmacion != null
        (element) => {
          if (element.confirmacion_ids && element.confirmacion_ids.length > 0) {
            return true;
          } else {
            return false;
          }
        }
      );

      // let band = true;
      // data.confirmations.forEach(row => {
      //   if (row.confirmation_date == null) {
      //     band = false;
      //     document.getElementById([
      //       "date" + row.disease_sample_detail_id
      //     ]).style.borderColor = "red";
      //   }
      // });

      // if (band) {
      Axios.postMasters(data)
        .then((response) => {
          SweetAlert.success(response.data.message);
          this.tableData = [];
          this.confirmationCatching = false;
        })
        .catch((error) => this.showMessageErrors(error));
      // }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('diseases/diseasesonly'),
      ])
        .then((response) => {
          this.farms = response[0].data.data;
          this.diseases = this.concatAll(response[1].data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('diseases/diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases/diseases');
  },
};
</script>
